export default {
  mediaPlayPause: 179,
  mediaStop: 178,
  nextTrack: 176,
  prevTrack: 177
};
